import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getRoles = createAsyncThunk(
  "Role/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();

      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          // If the value is an array, append each item with the same key
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          // For non-array values, just append normally
          params.append(key, value);
        }
      }
      const queryString = params.toString();

      const { data } = await axios.get(`${API_URL.ROLE.SLUG}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createRole = createAsyncThunk(
  "Role/create",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.post(`${API_URL.ROLE.SLUG}`, payload);
      const { active_payload } = getState().role;
      dispatch(getRoles(active_payload));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "Role/delete",
  async (id, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.delete(`${API_URL.ROLE.SLUG}/${id}`);
      const { active_payload } = getState().role;
      dispatch(getRoles(active_payload));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editRole = createAsyncThunk(
  "Role/put",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.put(`${API_URL.ROLE.SLUG}`, payload);
      const { active_payload } = getState().role;
      dispatch(getRoles(active_payload));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getRoleRightData = createAsyncThunk(
  "Role/getRoleRightData",
  async (roleId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.ROLE.ROLE_RIGHT}?roleId=${roleId}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const saveRoleRightData = createAsyncThunk(
  "Role/saveRoleRightData",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API_URL.ROLE.ROLE_RIGHT}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const roleSlice = createSlice({
  name: "role",
  initialState: {
    role_list: [],
    current_values: null,
    active_payload: null,
    role_loading: false,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRoles.fulfilled, (state, action) => {
      state.role_list = action.payload.data.list;
    });
    builder
      .addCase(getRoleRightData.pending, (state) => {
        state.role_loading = true;
      })
      .addCase(getRoleRightData.fulfilled, (state, action) => {
        state.role_right_data = action.payload;
        state.role_loading = false;
      });
  },
});

export const { setCurrentValues, setActivePayload } = roleSlice.actions;
export default roleSlice.reducer;
